module.exports = {
	forceScope: 'art_form', // TODO: forceScope necessary since scope rework?

	extends: [
		'/',
		'templates',
		'artCrm',
		'address',
		'details'
	],

	methods: {
		dataDealer: function(){
			this.model.address = this.getResourceRegisterContent('addressAttributes') || {};
		},

		prepare: function(storage){
			var address = this.model.address || {};
			var content = [];
			var elements;
			const langCode = storage.langCode || appConfig.language.default || 'de-at'

			// prepare human readable salutation from categoryPicker
			var options 	= (((this.model.fields || [])[0] || {})['category-picker-data'] || {}).options || [];
			var salutation	= address.salutation;
			if(address.salutation && options.length > 0){
				var o, option;
				for(o in options){
					option = options[o];
					if(option.value === address.salutation){
						if(((option.lang || {})[langCode] || {}).name){
							salutation = option.lang[langCode].name;
						}
						break;
					}
				}
			}
			if(address.salutation === 'm' && salutation === 'Herr') salutation = 'Herrn';

			// prepare address content
			if(address.organisation){
				content.push(address.organisation);

				elements = ['z.H.'];
				if(salutation) 			elements.push(salutation);
				if(address.title) 		elements.push(address.title);
				if(address.firstName) 	elements.push(address.firstName);
				if(address.lastName) 	elements.push(address.lastName);
				if(elements.length > 0) content.push(elements.join(' '));
			}
			else {
				if(salutation) 			content.push(salutation);

				elements = [];
				if(address.title) 		elements.push(address.title);
				if(address.firstName) 	elements.push(address.firstName);
				if(address.lastName) 	elements.push(address.lastName);
				if(elements.length > 0) content.push(elements.join(' '));
			}

			elements = [];
			if(address.street) 		elements.push(address.street);
			if(elements.length > 0) content.push(elements.join(' '));

			elements = [];
			if(address.zip) 			elements.push(address.zip);
			if(address.city) 			elements.push(address.city);
			if(elements.length > 0) 	content.push(elements.join(' '));

			// prepare human readable country from categoryPicker
			options 		= (((this.model.fields || [])[1] || {})['category-picker-data'] || {}).options || [];
			var country		= address.country;
			if(address.country && options.length > 0){
				for(o in options){
					option = options[o];
					if(option.value === address.country){
						if(((option.lang || {})[langCode] || {}).name){
							country = option.lang[langCode].name;
						}
						break;
					}
				}
			}
			if(country) 		content.push(String(country).toUpperCase());

			this.model.content = content.join("\n");
		}
	}
}